<div class="container text-center" *ngIf="WarrantyDetailsInfo">
    <h3 class="title">{{'WarrantyCertificate'|translate}}</h3>
    <img src="../../../../assets/images/certification.jpg" width="250" height="200" />
    <div class="section">
        <p class="p1">تهنئة صادقة وشكر عميق لانضمامك إلي أسرة Polywin</p>
        <p>

            إن قرارك بتركيب أي منتج من خامات Polywin يعني أنك تقدر التميز .. وتثمن خدمة ما بعد البيع التي تقدمها لك
            الورشة المعتمدة من Polwin
            فمرحبا بك عضوا فاعلا في عائلة Polywin
        </p>
        <ul>
            <li>تضمن Polywin هذا المنتج ضد عيوب الصناعة وتغير اللون</li>
            <li> تضمن ورشة <span class="name">{{UserInfo.name}}</span> هذا المنتج ضد عيوب التصنيع في حالة الاستخدام
                والصيانة
                الطبيعيه
                فقط.</li>
            <li>ينحصر التزام ورشة : <span class="name">{{UserInfo.name}}</span> بمقتضى هذا الضمان في اصلاح او استبدال أي
                منتج من
                المنتجات التي تم تركيبها بتحقيق
                الشركة أنه من عيوب الصناعة ولا يغطي هذا الضمان سوء الاتسخدام</li>
            <li> يجب اصلاح المنتجات عن طريق ورشة: <span class="name">{{UserInfo.name}}</span> دول غيرها ولا سقط الحق في
                الضمان
            </li>
        </ul>

        <p class="yellow">هذا الضمان لا يسري في الحالات الأتية</p>
        <ul>
            <li>الأضرار الناتجة عن الحوارات أو سوء الاستخدام</li>
        </ul>
    </div>

    <div class="data">
        <table class="table text-center">
            <tr>
                <td class="td-title">{{ 'InstallationDate' | translate }}</td>
                <td class="td-data">{{WarrantyDetailsInfo.startSectorsWarrantyDate|date:'yyyy/MM/dd'}}</td>
            </tr>

            <tr>
                <td class="td-title"> {{ 'ClientName' | translate }}</td>
                <td class="td-data">{{WarrantyDetailsInfo.clientName}}</td>
            </tr>

            <tr>
                <td class="td-title"> {{ 'ClientPhone' | translate }}</td>
                <td class="td-data">{{WarrantyDetailsInfo.clientPhone}}</td>
            </tr>

            <tr>
                <td class="td-title">{{ 'Address' | translate }} </td>
                <td class="td-data">{{WarrantyDetailsInfo.clientAddress}}</td>
            </tr>

            <tr>
                <td class="td-title">{{ 'WorkShopName' | translate }}</td>
                <td class="td-data">{{UserInfo.name}}</td>
            </tr>

            <tr>
                <td class="td-title">{{ 'WorkShopAddress' | translate }}</td>
                <td class="td-data">{{UserInfo.agentAddress}}</td>
            </tr>

            <tr>
                <td class="td-title">{{ 'Governorate' | translate }}</td>
                <td class="td-data">{{UserInfo.agentGovernorate}}</td>
            </tr>
        </table>
    </div>

    <div class="section">
        <h3 class="title">{{'ProductsDetails'|translate}}</h3>
        <div class="col-lg-6 col-sm-4 m-b-15" *ngFor="let cost of WarrantyDetailsInfo.costCalcs">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">{{cost.productName}}</mat-card-title>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content text-center">
                    <table class="data-table">
                        <tr>
                            <td>
                                <span class="span-title">{{ 'height' | translate }} : </span>
                                <span>{{ cost.height}} {{'Meter'|translate}}</span>
                            </td>
                            <td>
                                <span class="span-title"> {{ 'width' | translate }} : </span>
                                <span>{{ cost.width }} {{'Meter'|translate}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="span-title">{{ 'Count' | translate }} : </span>
                                <span>{{ cost.count }}</span>
                            </td>
                            <td>
                                <span class="span-title">{{ 'Color' | translate }} :</span>
                                <span> {{ cost.colorName}}</span>
                            </td>
                        </tr>
                    </table>
                    <mat-card-title class="mat-mdc-card-title text-blue">{{ 'Images' | translate }}</mat-card-title>
                    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                        <mat-card-content class="mat-mdc-card-content text-center">
                            <div class="row">
                                <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let img of cost.listImage">
                                    <img alt="{{cost.productName}}" width="80" height="80" class="m-auto ms-5"
                                        src="{{img | adjust_image_path}}">
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </mat-card-content>
            </mat-card>
        </div>

        <mat-divider></mat-divider>

        <div class="row m-t-24">
            <div class="col-sm-12">
                <button mat-button class="Cancelbtn" (click)="Cancel()"> {{ 'Cancel' | translate}}</button>
            </div>
        </div>
    </div>
</div>
